import { render, staticRenderFns } from "./notificationView.vue?vue&type=template&id=752415c5&scoped=true"
import script from "./notificationView.vue?vue&type=script&lang=js"
export * from "./notificationView.vue?vue&type=script&lang=js"
import style0 from "./notificationView.vue?vue&type=style&index=0&id=752415c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752415c5",
  null
  
)

export default component.exports